function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import "./cintillo.scss";
import { string, oneOf, node, any } from "prop-types";

const Cintillo = ({
  title,
  imgProps = {},
  className = "",
  backgroundColor,
  rightSide
}) => {
  return React.createElement("div", {
    className: "cintillo ".concat(className)
  }, React.createElement("div", {
    className: "flag_container",
    style: {
      backgroundColor
    }
  }, React.createElement("img", _extends({
    className: "flag_icon"
  }, imgProps)), React.createElement("span", {
    className: "flag_text"
  }, title)), React.createElement("div", {
    className: "info_container"
  }, rightSide));
};

Cintillo.propTypes = {
  className: string,
  title: string.isRequired,
  imgProps: any,
  backgroundColor: string,
  rightSide: oneOf([node, string])
};
export default Cintillo;